function createElementAsString(nodeName, attributes, children) {
  let htmlParts = [`<${nodeName}`];
  if (typeof attributes === "object") {
    for (const key in attributes) {
      const value = attributes[key];
      if (typeof value !== "undefined") {
        if (typeof value === "string" || typeof value === "number") {
          htmlParts.push(` ${key}="${value}"`);
        } else if (value) {
          htmlParts.push(` ${key}`);
        }
      }
    }
  }
  htmlParts.push(">");
  if (typeof children === "string") {
    htmlParts.push(children);
  }
  htmlParts.push(`</${nodeName}>`);
  return htmlParts.join("");
}
function getAttribute(element, attributeName, defaultValue) {
  const value = element.getAttribute(`${attributeName}`);
  if (typeof defaultValue === "number") {
    if (value) {
      return +value;
    } else {
      return defaultValue;
    }
  } else if (typeof defaultValue === "boolean") {
    if (value) {
      if (value === "false") {
        return false;
      } else {
        return true;
      }
    } else {
      if (element.hasAttribute(`${attributeName}`)) {
        return true;
      } else {
        return defaultValue;
      }
    }
  }
  return value || defaultValue;
}
const HTMLUtils = {
  createElementAsString,
  getAttribute
};

export { HTMLUtils };
//# sourceMappingURL=html-utils.js.map
